export default "__VITE_PUBLIC_ASSET__40bbbca4__"